module.exports = __webpack_public_path__ + "static/media/christina-starfire.13bf60c7.md";